import { inject } from '@angular/core';
import { Router } from '@angular/router';
import { SupabaseSession } from '@itavan/lib/core/supabase';
import { firstValueFrom } from 'rxjs';

export const publicGuard = async () => {
  const authService = inject(SupabaseSession);
  const router = inject(Router);

  const session = await firstValueFrom(authService.session$);

  // user is already authenticated
  if (session?.user) {
    router.navigate(['/memorials']);
    return false;
  } else {
    return true;
  }
};
